export const initialState = {
  values: {
    businessSelected: "",
    firstName:"",
    lastName:"",
    joinDate:"",
    email: "",
    password: "",
    confirmPassword: "",
    city: '',
    country: '',
    countryCode:"",
    mobileNumber: '',
    showPassword: false,
    latitudes: "",
    longitues: "",
    preferedLanguage: "",
    provider: "Personal",
    userImage: "",
  },
  errors: {
    businessSelected: "",
    firstName:"",
    lastName:"",
    email: "",
    password: "",
    confirmPassword: "",
    city: '',
    country: '',
    state: '',
    mobileNumber: '',
    provider: "",
  },
}
